// extracted by mini-css-extract-plugin
export default {"root":"Stars_root__SoJaZ","icon":"Stars_icon__AuRdn"};